/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Push_TitleInputs */

const en_push_title = /** @type {(inputs: Push_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`On this device`)
};

/**
* | output |
* | --- |
* | "On this device" |
*
* @param {Push_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const push_title = /** @type {((inputs?: Push_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_push_title(inputs)
});